export default "__VITE_ASSET__DL8ZmBbg__"